import { __assign, __extends, __rest } from "tslib";
import React from "react";
import { Clipboard, StyleSheet, TouchableWithoutFeedback, View, Text, TouchableOpacity } from "react-native";
import { PulseLoader as BusyTyping } from "react-spinners";
import PnmacMessageText from "../MessageText/PnmacMessageText";
import PnmacMessageImage from "../MessageImage/PnmacMessageImage";
import PnmacTime from "../Time/PnmacTime";
import { isSameUser, isSameDay, isHTML } from "../utils";
import PropTypes from "prop-types";
import styles from "./PnmacBubble.styles";
var PnmacBubble = /** @class */function (_super) {
  __extends(PnmacBubble, _super);
  function PnmacBubble() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onLongPress = function () {
      if (_this.props.onLongPress) {
        _this.props.onLongPress(_this.context);
      } else {
        if (_this.props.currentMessage.text) {}
      }
    };
    _this.renderChildren = function () {
      var _a, _b, _c, _d;
      var _e = _this.props,
        currentMessage = _e.currentMessage,
        macResponse = _e.macResponse;
      var title = ((_a = currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.children) === null || _a === void 0 ? void 0 : _a.title) != "" && ((_b = currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.children) === null || _b === void 0 ? void 0 : _b.title) != null;
      var links = (_c = currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.children) === null || _c === void 0 ? void 0 : _c.map(function (s, i) {
        var _a, _b;
        return /*#__PURE__*/React.createElement(TouchableOpacity, {
          key: i,
          onPress: function () {
            return macResponse(s.label);
          }
        }, /*#__PURE__*/React.createElement(View, {
          style: styles.choiceStlyesContainer
        }, /*#__PURE__*/React.createElement(Text, {
          style: styles.choiceStlyesText
        }, (_b = (_a = s.value) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.text)));
      });
      return /*#__PURE__*/React.createElement(View, {
        style: styles.childrenContainer
      }, title ? /*#__PURE__*/React.createElement(View, null, (_d = currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.children) === null || _d === void 0 ? void 0 : _d.title) : null, /*#__PURE__*/React.createElement(View, null, links));
    };
    return _this;
  }
  PnmacBubble.prototype.handleBubbleToNext = function () {
    if (isSameUser(this.props.currentMessage, this.props.nextMessage) && isSameDay(this.props.currentMessage, this.props.nextMessage)) {
      return StyleSheet.flatten([styles[this.props.position].containerToNext, this.props.containerToNextStyle[this.props.position]]);
    }
    return null;
  };
  PnmacBubble.prototype.handleBubbleToPrevious = function () {
    if (isSameUser(this.props.currentMessage, this.props.previousMessage) && isSameDay(this.props.currentMessage, this.props.previousMessage)) {
      return StyleSheet.flatten([styles[this.props.position].containerToPrevious, this.props.containerToPreviousStyle[this.props.position]]);
    }
    return null;
  };
  PnmacBubble.prototype.renderMessageText = function () {
    if (this.props.isTypingEvent) {
      return /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 10
        }
      }, /*#__PURE__*/React.createElement(BusyTyping, {
        color: "#7ED321",
        size: "10",
        margin: "5"
      }));
    }
    if (this.props.currentMessage.text) {
      var _a = this.props,
        containerStyle = _a.containerStyle,
        wrapperStyle = _a.wrapperStyle,
        messageTextProps = __rest(_a, ["containerStyle", "wrapperStyle"]);
      if (this.props.renderMessageText && isHTML(messageTextProps.currentMessage.text)) {
        return this.props.renderMessageText(messageTextProps);
      }
      return /*#__PURE__*/React.createElement(PnmacMessageText, __assign({}, messageTextProps));
    }
    return null;
  };
  PnmacBubble.prototype.renderMessageImage = function () {
    if (this.props.currentMessage.image) {
      var _a = this.props,
        containerStyle = _a.containerStyle,
        wrapperStyle = _a.wrapperStyle,
        messageImageProps = __rest(_a, ["containerStyle", "wrapperStyle"]);
      if (this.props.renderMessageImage) {
        return this.props.renderMessageImage(messageImageProps);
      }
      return /*#__PURE__*/React.createElement(PnmacMessageImage, __assign({}, messageImageProps));
    }
    return null;
  };
  PnmacBubble.prototype.renderTime = function () {
    if (this.props.currentMessage.createdAt) {
      var _a = this.props,
        containerStyle = _a.containerStyle,
        wrapperStyle = _a.wrapperStyle,
        timeProps = __rest(_a, ["containerStyle", "wrapperStyle"]);
      if (this.props.renderTime) {
        return this.props.renderTime(timeProps);
      }
      return /*#__PURE__*/React.createElement(PnmacTime, __assign({}, timeProps));
    }
    return null;
  };
  PnmacBubble.prototype.render = function () {
    return /*#__PURE__*/React.createElement(View, {
      style: [styles[this.props.position].container],
      testID: "bubble",
      nativeID: this.props.scrollId
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles[this.props.position].wrapper, this.props.wrapperStyle[this.props.position], this.handleBubbleToNext(), this.handleBubbleToPrevious(), this.props.currentMessage && this.props.currentMessage.iconOnTopLeft ? {
        paddingTop: 15,
        paddingLeft: 15
      } : {}]
    }, /*#__PURE__*/React.createElement(TouchableWithoutFeedback, __assign({
      onLongPress: this.onLongPress,
      accessibilityTraits: "text"
    }, this.props.touchableProps), /*#__PURE__*/React.createElement(View, null, this.renderMessageImage(), this.renderMessageText(), this.renderChildren(), this.renderTime()))));
  };
  return PnmacBubble;
}(React.Component);
PnmacBubble.contextTypes = {
  actionSheet: PropTypes.func
};
PnmacBubble.defaultProps = {
  touchableProps: {},
  onLongPress: null,
  renderMessageImage: null,
  renderMessageText: null,
  renderCustomView: null,
  renderTime: null,
  position: "left",
  currentMessage: {
    text: null,
    createdAt: null,
    image: null
  },
  nextMessage: {},
  previousMessage: {},
  containerStyle: {},
  wrapperStyle: {},
  containerToNextStyle: {},
  containerToPreviousStyle: {}
};
PnmacBubble.propTypes = {
  touchableProps: PropTypes.object,
  onLongPress: PropTypes.func,
  renderMessageImage: PropTypes.func,
  renderMessageText: PropTypes.func,
  renderCustomView: PropTypes.func,
  renderTime: PropTypes.func,
  position: PropTypes.oneOf(["left", "right"]),
  currentMessage: PropTypes.object,
  nextMessage: PropTypes.object,
  previousMessage: PropTypes.object,
  containerStyle: PropTypes.shape({
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
  }),
  wrapperStyle: PropTypes.shape({
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
  }),
  containerToNextStyle: PropTypes.shape({
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
  }),
  containerToPreviousStyle: PropTypes.shape({
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
  })
};
export default PnmacBubble;